// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1fMIk","cardBody":"styles_cardBody__258_h"};